/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, October 20th 2021, 12:57:03 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { Outlet } from "react-router-dom";
import { Box } from "ui-widgets";

/* Feather Icons */
import { Check } from "react-feather";
import { ADMIN_CONSOLE_THEME } from "theme/styles";

export const AuthBaseLayout = () => {
  return (
    <Box className="auth-base-file-1 auth-page-container" display="flex" justifyContent="center" alignItems="center">
      <Box className="auth-content-out" display={{ sm: "none", md: "inherit" }}>
        <div className="auth-content-section">
          <div className="auth-brand-wrapper2">
            <img
              className="image-style-A"
              src={ADMIN_CONSOLE_THEME.logo_url || "/img/onestop-full-logo-white.svg"}
              alt="Logo"
            />
          </div>
          <div className="auth-base-content">
            {ADMIN_CONSOLE_THEME.is_custom_theme ? (
              <h1>{ADMIN_CONSOLE_THEME.slogan}</h1>
            ) : (
              <>
                <h1>
                  Build and deploy services online with the <b>Onestop Admin Portal</b>
                </h1>
                <ul>
                  <li>
                    <Check /> <span>Hosted Online Portals</span>
                  </li>
                  <li>
                    <Check /> <span>Cost Effective Automation</span>
                  </li>
                  <li>
                    <Check /> <span>Collaborative Approval Workflows</span>
                  </li>
                  <li>
                    <Check /> <span>Eco-friendly Paperless Environment</span>
                  </li>
                  <li>
                    <Check /> <span>Digitally Approved Documents</span>
                  </li>
                  <li>
                    <Check /> <span>Seamless System Integration</span>
                  </li>
                  <li>
                    <Check /> <span>AI Workers</span>
                  </li>
                  <li>
                    <Check /> <span>Data Protection &amp; Privacy</span>
                  </li>
                </ul>
              </>
            )}
          </div>
        </div>
      </Box>
      <Box className="auth-wrapper-out" sx={{}}>
        {/* Outlet is new in react-router v6 that allows nested route components to be placed here. So we have a parent route for all routes that will use the AuthBaseLayout. */}
        <Outlet />
      </Box>
    </Box>
  );
};
